import { FunctionComponent } from 'react';
import { Image, Button, Text, VStack, Stack } from '@chakra-ui/react';
import { images } from '../support/imageSupport';
import BtButton, { ButtonParams } from './BtButton';
import { LANDING_SCREEN_PATH } from '../support/routeConstants';
import LanguageSwitcher from './BtLanguageSwitcher';

export interface NavigateFooterParams {
  title: string;
  image: string;
  path: string;
}

interface NavigateFooterProps {
  title: string;
  image: string;
  path: string;
  onClick: (path: string) => void;
}

export const BtNavigateFotter: FunctionComponent<NavigateFooterProps> = ({
  title,
  image,
  path,
  onClick,
}) => {
  return (
    <Button variant='ghost' onClick={() => onClick(path)}>
      <VStack>
        <Image src={images(image)} alt={title} />
        <Text ml={1} fontSize='sm' color='brand.500' fontWeight='400'>
          {title}
        </Text>
      </VStack>
    </Button>
  );
};

export interface NavigateParams {
  home: ButtonParams;
  image: any;
  back: ButtonParams;
}

interface NavigateProps {
  home: ButtonParams;
  image: string;
  back: ButtonParams;
  onClick: (path: string) => void;
}

export const BtNavigate: FunctionComponent<NavigateProps> = ({ home, image, back, onClick }) => {
  return (
    <Stack w='full' padding='30px' direction={['row', 'row']} justifyContent={'space-between'}>
      <BtButton variant='ghost' {...back} action={() => onClick('')} />
      {image !== '' &&
        (image?.startsWith('http') ? (
          <Image
            src={image?.startsWith('http') ? image : images(image)}
            alt='Logo'
            maxHeight='60px'
            objectFit='contain'
          />
        ) : (
          <Image src={images(image)} boxSize='140px' objectFit='contain' alt='Logo' />
        ))}
      {/* <LanguageSwitcher />*/}
      <BtButton variant='ghost' {...home} action={() => onClick(LANDING_SCREEN_PATH)} />
    </Stack>
  );
};
